let en = {
  Title: "About Us",
  Team: [
    {Avatar: '/static/team/liyingxuan.jpg', Name: 'Yingxuan Li', Title: 'Co-Founder'},
    {Avatar: '/static/team/wanghuaiyu.jpg', Name: 'Huaiyu Wang', Title: 'Co-Founder'},
    {Avatar: '/static/team/linchengxi.jpg', Name: 'Chengxi Lin', Title: 'Chief Strategy Officer'},
    {Avatar: '/static/team/qiaoyi.jpg', Name: 'Yi Qiao', Title: 'Chief Operating Officer'},
    {Avatar: '/static/team/zhangwei.jpg', Name: 'Wei Zhang', Title: 'Senior Advisor'},
  ],
  Content: "Our team is made up of leaders, core development engineers, and community developers of leading blockchain enterprise and projects Onchain, Ontology, TRON, and Bitkeep. We have rich technical accumulation and in-depth understanding in the blockchain field. We are working on blockchain's standardize and protocolize, and will provide a complete infrastructure solution to enable blockchains to powered various fields.",
}

let zh ={
  Title: '关于我们',
  Team: [
    {Avatar: '/static/team/liyingxuan.jpg', Name: '李颖轩', Title: '联合创始人'},
    {Avatar: '/static/team/wanghuaiyu.jpg', Name: '王怀宇', Title: '联合创始人'},
    {Avatar: '/static/team/linchengxi.jpg', Name: '林承羲', Title: '首席战略官'},
    {Avatar: '/static/team/qiaoyi.jpg', Name: '乔轶', Title: '首席运营官'},
    {Avatar: '/static/team/zhangwei.jpg ', Name: '张伟', Title: '高级顾问'},
  ],
  Content: ' 我们的团队来自Onchain、Ontology、TRON、Bitkeep等领先的区块链企业项目的领导者、核心开发工程师、社区开发人员，在区块链领域拥有丰富的技术积累和深入的理解。我们将实现区块链的标准化、协议化为区块链之间的链接及落地应用，提供一套完备的基础设施，让区块链能够在各个领域的释放自己的力量。',
}

let name = 'AboutUs'

export default {
  name,
  en,
  zh
}